export default __webpack_public_path__ + "static/media/DNo.1-3.f9b0d4b3.jpg";